export const STORE = 'store';
export const TAG = 'tag';
export const MARKETPLACE = 'marketplace';
export const SHIP_FROM = 'shipFrom';
export const PACKAGE_TYPE = 'package';
export const INSURANCE = 'insurance';
export const ASSIGNED_TO = 'assignedTo';
export const PROVIDER = 'provider';
export const RESIDENTIAL_OR_COMMERCIAL = 'residentialOrCommercial';
export const SHIPPING_ACCOUNT = 'shippingAccount';
export const SERVICE = 'service';
// TODO: this should be renamed RATE_SHOPPER
export const SERVICE_COLLECTION = 'serviceCollection';
export const FULFILLMENT_PROVIDER = 'fulfillmentProvider';
export const WAREHOUSE_STATUS = 'warehouseStatus';
export const PICKING_EXCEPTION = 'pickingException';
export const PICK_BATCH = 'pickBatch';
export const PICK_BATCH_ASSIGNEE = 'pickBatchAssignee';
export const REFUND_STATUS = 'refundStatus';
export const VOID_TYPE = 'voidType';
export const TOTE = 'tote';
export const MULTI_PACKAGE = 'IsMultiPackage';
export const PICK_BATCH_QUEUE = 'IsPickBatchQueue';
export const SERIAL_NUMBER = 'serialNumber';
export const SHIPPING_MODE = 'shippingMode';
